import React from 'react';

export const ModalRegs = () => (
  <p>
    Access to information regarding the issuer is only made available to
    Non-U.S. persons outside of the United States within the meaning of
    Regulation S promulgated under the Securities Act of 1933, as amended (the
    “Securities Act”). NOTHING CONTAINED HEREIN CONSTITUTES AN OFFER TO SELL
    SECURITIES OR THE SOLICITATION OF AN OFFER TO PURCHASE ANY SECURITIES IN ANY
    JURISDICTION. Neither the depositary receipts nor the underlying securities
    of the issuer to which this certification relates have been or will be
    registered under the Securities Act or any United States state securities
    laws. <br />
    <br />
    By clicking “I Accept” below and accessing the information on this website,
    you are certifying and agreeing to the following: (a) you have read,
    understood and agree to this disclaimer, (b) you have independently informed
    yourself of any legal restrictions and represent to JPMorgan Chase Bank,
    N.A. and each of its affiliated entities, including, without limitation,
    J.P. Morgan AG, that by accessing the information contained on this website,
    you are not in violation of, and will not be causing the issuer of the
    underlying securities, JPMorgan Chase Bank, N.A. or any of J.P. Morgan Chase
    Bank, N.A.&apos;s affiliated entities, including, without limitation, J.P.
    Morgan AG, to violate, any applicable laws and, as a result, you are legally
    authorized to access such information, (c) you understand and acknowledge
    that the information you are about to see relates to a security or
    securities that has/have not been registered under the Securities Act, and
    may not be offered or sold within the United States (within the meaning of
    Regulation S under the Securities Act) or to, or for the account or benefit
    of, U.S. persons (as such term is defined in Regulation S under the
    Securities Act), (d) you are a Non-U.S. person (as defined in Regulation S
    under the Securities Act) located outside of the United States (within the
    meaning of Regulation S under the Securities Act) and (e) access to this
    website has been limited so that it shall not constitute directed selling
    efforts (as defined in Regulation S under the Securities Act) in the United
    States.
  </p>
);

export const Modal114A = () => (
  <p>
    Access to information regarding the issuer is only made available to
    “qualified institutional buyers” within the meaning of Rule 144A promulgated
    under the Securities Act of 1933, as amended (the “Securities Act”). NOTHING
    CONTAINED HEREIN CONSTITUTES AN OFFER TO SELL SECURITIES OR THE SOLICITATION
    OF AN OFFER TO PURCHASE ANY SECURITIES IN ANY JURISDICTION. Neither the
    depositary receipts nor the underlying securities of the issuer to which
    this certification relates have been or will be registered under the
    Securities Act or any United States state securities laws.
    <br />
    <br /> By clicking “I Accept” below and accessing the information on this
    website, you are certifying and agreeing to the following: (a) you have
    read, understood and agree to this disclaimer, (b) you have independently
    informed yourself of any legal restrictions and represent to JPMorgan Chase
    Bank, N.A. each of its affiliated entities, including, without limitation,
    J.P. Morgan AG, that by accessing the information contained on this website,
    you are not in violation of, and will not be causing the issuer of the
    underlying securities, JPMorgan Chase Bank, N.A. or any of J.P. Morgan Chase
    Bank, N.A.&apos;s affiliated entities, including, without limitation, J.P. Morgan
    AG, to violate, any applicable laws and, as a result, you are legally
    authorized to access such information, (c) you understand and acknowledge
    that the information you are about to see relates to a security or
    securities that has/have not been registered under the Securities Act, and
    may only be offered and sold to qualified institutional buyers (as such term
    if defined in Rule 144A under the Securities Act), (d) you are a qualified
    institutional buyer (as defined in Rule 144A under the Securities Act)
    acting for your own account or the accounts of other qualified institutional
    buyers, and (e) access to this website has been limited so that it shall not
    constitute general advertising or general solicitation (within the meaning
    of Regulation D under the Securities Act).
  </p>
);

export const CusipUseDisclaimer = () => (
  <React.Fragment>
    The CUSIP information contained in ADR.com consists of security identifiers and
    related descriptive information (“the CUSIP Database”) and certain CUSIP
    identifiers and related descriptive data (“CUSIP Data”) and is protected under
    the copyright laws and is licensed with permission from CUSIP Global Services
    (“CGS”), on behalf of the American Bankers Association (ABA).<br />
    <br />
    VISITOR agrees and acknowledges that the CUSIP Database and the information
    contained therein is and shall remain valuable intellectual property owned by,
    or licensed to, CUSIP Global Services and the American Bankers Association
    (“ABA”), and that no proprietary rights are being transferred to VISITOR in
    such materials or in any of the information contained therein. Any use of the
    CUSIP Data by VISITOR outside of the clearing and settlement of transactions
    requires a license from CGS, along with an associated fee based on usage.
    VISITOR agrees that misappropriation or misuse of such materials will cause
    serious damage to CGS and ABA, and that in such event money damages may not
    constitute sufficient compensation to COS and ABA; consequently, VISITOR
    agrees that in the event of any misappropriation or misuse, CGS and ABA shall
    have the right to obtain injunctive relief in addition to any other legal or
    financial remedies to which CGS and ABA may be entitled.<br />
    <br />
    VISITOR agrees that it shall not publish nor distribute in any medium the
    CUSIP Database or any substantial portion of the information contained therein
    or summaries or subsets thereof to any person or entity. VISITOR may not
    create or maintain a master file or database of CUSIP identifiers or
    descriptions for itself or any third party recipient that is intended to
    serve as a substitute for any CUSIP service.<br />
    <br />
    VISITOR agrees not to:<br />
    <br />
    (1) Violate the restrictions in any robot inclusion headers on the Licensee
    Web Site or in any way bypass or circumvent any other measure employed to
    limit or prevent access to the CUSIP Data on the Licensee Web Site;<br />
    <br />
    (2) Violate the security of the Licensee Web Site or attempt to gain
    unauthorized access to the Web Site, CUSIP Data, materials, information,
    computer systems or networks connected to Licensee server, through hacking,
    password mining or any other means; or<br />
    <br />
    (3) Interfere or attempt to interfere with the proper working of the
    Licensee Web Site or any activities conducted on or through the Licensee
    Web Site, including accessing any CUSIP Data, content or other information
    prior to the time that is intended to be available to the public on the
    Licensee Web Site;<br />
    <br />
    Visitor acknowledges that certain information will be provided to CGS in
    connection with Visitor&apos;s downloading of CUSIP Data, which may include
    Visitor User Name, Firm Name downloaded by each Visitor. This information
    will be used for purposes of monitoring compliance with these Terms. This
    information will be stored securely in the U.S. and may be reviewed and
    correct by contacting: CUSIP_license@CUSIP.com. For additional information
    about our Customer Privacy practices, please see: www.CUSIP.com.<br />
    <br />
    NEITHER CGS, ABA NOR ANY OF THEIR AFFILIATES MAKE ANY WARRANTIES, EXPRESS OR
    IMPLIED, AS TO THE ACCURACY, ADEQUACY OR COMPLETENESS OF ANY OF THE
    INFORMATION CONTAINED IN THE CUSIP DATABASE. ALL SUCH MATERIALS ARE PROVIDED
    TO VISITOR ON AN “AS IS” BASIS, WITHOUT ANY WARRANTIES AS TO MERCHANTABILITY
    OR FITNESS FOR A PARTICULAR PURPOSE OR USE NOR WITH RESPECT TO THE RESULTS
    WHICH MAY BE OBTAINED FROM THE USE OF SUCH MATERIALS. NEITHER CGS, ABA NOR
    THEIR AFFILIATES SHALL HAVE ANY RESPONSIBILITY OR LIABILITY FOR ANY ERRORS
    OR OMISSIONS NOR SHALL THEY BE LIABLE FOR ANY DAMAGES, WHETHER DIRECT OR
    INDIRECT, SPECIAL OR CONSEQUENTIAL, EVEN IF THEY HAVE BEEN ADVISED OF THE
    POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL THE LIABILITY OF CGS, ABA OR
    ANY OF THEIR AFFILIATES PURSUANT TO ANY CAUSE OF ACTION, WHETHER IN CONTRACT,
    TORT, OR OTHERWISE, EXCEED THE FEE PAID BY VISITOR FOR ACCESS TO SUCH MATERIALS
    IN THE MONTH IN WHICH SUCH CAUSE OF ACTION IS ALLEGED TO HAVE ARISEN. FURTHERMORE,
    CGS AND ABA SHALL HAVE NO RESPONSIBILITY OR LIABILITY FOR DELAYS OR FAILURES DUE
    TO CIRCUMSTANCES BEYOND THEIR CONTROL.<br />
    <br />
    VISITOR agrees that the foregoing terms and conditions shall survive any
    termination of its right of access to the materials identified above.<br />
    <br />
  </React.Fragment>
);

export const ModalCusipUse = () => (
  <p>
    Please read and indicate your acceptance of these Additional Terms by clicking on the link at the bottom of the page.
    You are about to enter into an Agreement with CUSIP Global Services. If you do not agree with these terms, then
    please do not click “I Accept”. By clicking “I Accept”, you agree to accept and be bound by the terms and conditions
    of this agreement.<br />
    <br />
    <CusipUseDisclaimer />
  </p>
);
